import React from 'react';
import { styled } from 'linaria/react';
import { theme } from '../../../Theme';
import SectionWrapper from '../../../Layout/SectionWrapper';

const TextBlockWrapper = styled(SectionWrapper)`
  width: 100%;
  max-width: 1440px;
  display: flex;
  margin: 0 auto;
  justify-content: ${({ position }) =>
    getPositionStyles(position).alignContent};
  padding: 0 111px 0 111px;

  ${theme.below.sm} {
    padding: 0 16px 0 16px;
  }
`;

const getPositionStyles = position => {
  return {
    alignContent:
      position === 'center'
        ? 'center'
        : position === 'left'
        ? 'flex-start'
        : 'flex-end',
    alignItems:
      position === 'center'
        ? 'center'
        : position === 'left'
        ? 'flex-start'
        : 'flex-end',
    textAlign: position === 'center' ? 'center' : 'left'
  };
};

const ContentWrapper = styled('div')`
  width: 100%;
  max-width: 684px;
  display: flex;
  gap: 16px;
  flex-direction: column;
  align-items: ${({ position }) => getPositionStyles(position).alignItems};
  text-align: ${({ position }) => getPositionStyles(position).textAlign};

  ${theme.below.sm} {
    padding: 0;
    align-items: flex-start;
  }
`;

const TextBlockItem = styled('p')`
  font-family: ${theme.fonts.primary};
  font-size: 16px;
  font-weight: 400;
  letter-spacing: -2;
  margin-bottom: 32px;

  ${theme.below.sm} {
    font-size: 14px;
  }
`;

const Heading = styled('h2')`
  font-family: ${theme.fonts.primary};
  font-size: 18px;
  font-weight: 600;
  margin-top: 16px;

  ${theme.below.sm} {
    font-size: 16px;
  }
`;

const QuoteText = styled('h1')`
  font-family: ${theme.fonts.secondary};
  font-size: 48px;
  font-weight: 325;
  margin-top: 32px;
  margin-bottom: 32px;
  line-height: 52.8px;
  letter-spacing: -2;

  ${theme.below.sm} {
    font-size: 32px;
    line-height: 38.4px;
    margin-bottom: 32px;
  }
`;

const QuoteTextName = styled('p')`
  font-size: 14px;
  font-weight: 400;
`;

const LargeText = styled('h1')`
  font-family: ${theme.fonts.secondary};
  font-size: 32px;
  font-weight: 325;
  margin-top: 32px;
  margin-bottom: 32px;
  line-height: 38.4px;
  letter-spacing: -2;

  ${theme.below.sm} {
    font-size: 24px;
    line-height: 28.8px;
    margin-bottom: 32px;
  }
`;

const LargeTextName = styled('p')`
  font-size: 14px;
  font-weight: 400;
`;

const BlockComponents = {
  body_text: ({ block }) => (
    <div>
      {block.body_text_heading && <Heading>{block.body_text_heading}</Heading>}
      <TextBlockItem>{block.body_text}</TextBlockItem>
    </div>
  ),
  quote_text: ({ block }) => (
    <div>
      <QuoteText>{block.quote_text}</QuoteText>
      {block.quote_text_name && (
        <QuoteTextName>{block.quote_text_name}</QuoteTextName>
      )}
    </div>
  ),
  large_text: ({ block }) => (
    <div>
      <LargeText>{block.large_text}</LargeText>
      {block.large_text_name && (
        <LargeTextName>{block.large_text_name}</LargeTextName>
      )}
    </div>
  )
};

const TextBlock = props => {
  const { position, body } = props;

  return (
    <TextBlockWrapper position={position}>
      <ContentWrapper position={position}>
        {body.map((block, index) => {
          const BlockComponent = BlockComponents[block.component];
          return BlockComponent ? (
            <BlockComponent key={index} block={block} />
          ) : null;
        })}
      </ContentWrapper>
    </TextBlockWrapper>
  );
};

export default TextBlock;
